/*
 *
 * Regex is responsible for matching mathjax syntax in the question input eg. $$x^2$$, $x^2$, \(x^2\)
 */
export const matchEquationRegex = /\$\$(.*?)\$\$|\$(.*?)\$|\\\((.*?)\\\)|\\\[(.*?)\\\]/g;
export const config = {
  tex: {
    inlineMath: [
      ["$", "$"],
      ["\\(", "\\)"],
    ],
    displayMath: [
      ["$$", "$$"],
      ["\\[", "\\]"],
    ],
  },
  loader: { load: ["input/tex", "output/svg"] },
};
